import React from "react";
import "./index.scss";
import Header from "../../components/appLayout/header";
import { useTranslation } from "../../hooks/useTranslation";

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const lastUpdated = "15-10-2025"; // Remplacez par la date réelle

  return (
    <>
      <Header />
      <main className="privacy-page mt-5" aria-labelledby="privacy-title">
        <div className="container">
          <header className="privacy-header">
            <h1 id="privacy-title">{t('privacyTitle')}</h1>
            <p className="last-updated">
              {t('privacyLastUpdated')} <strong>{lastUpdated}</strong>
            </p>
            <p className="lead">
              {t('privacyLead')}
            </p>
          </header>

          <section className="policy-section" id="information">
            <h2>{t('privacyInformation')}</h2>
            <p>{t('privacyInformationText')}</p>
            <ul>
              <li>
                <strong>{t('privacyPersonalInfo')}</strong> {t('privacyPersonalInfoText')}
              </li>
              <li>
                <strong>{t('privacyTechnicalData')}</strong> {t('privacyTechnicalDataText')}
              </li>
              <li>
                <strong>{t('privacyUsageData')}</strong> {t('privacyUsageDataText')}
              </li>
            </ul>
          </section>

          <section className="policy-section" id="use">
            <h2>{t('privacyHowWeUse')}</h2>
            <p>{t('privacyHowWeUseText')}</p>
            <ul>
              <li>{t('privacyUse1')}</li>
              <li>{t('privacyUse2')}</li>
              <li>{t('privacyUse3')}</li>
              <li>{t('privacyUse4')}</li>
            </ul>
          </section>

          <section className="policy-section" id="legal-basis">
            <h2>{t('privacyLegalBasis')}</h2>
            <p>
              {t('privacyLegalBasisText')}
            </p>
            <ul>
              <li>{t('privacyConsent')}</li>
              <li>{t('privacyContract')}</li>
              <li>{t('privacyLegalObligations')}</li>
              <li>
                {t('privacyLegitimateInterests')}
              </li>
            </ul>
          </section>

          <section className="policy-section" id="retention">
            <h2>{t('privacyRetention')}</h2>
            <p>
              {t('privacyRetentionText')}
            </p>
          </section>

          <section className="policy-section" id="sharing">
            <h2>{t('privacySharing')}</h2>
            <p>
              {t('privacySharingText')}
            </p>
            <ul>
              <li>
                {t('privacySubsidiaries')}
              </li>
              <li>
                {t('privacyServiceProviders')}
              </li>
              <li>{t('privacyLegalAuthorities')}</li>
            </ul>
          </section>

          <section className="policy-section" id="security">
            <h2>{t('privacySecurity')}</h2>
            <p>
              {t('privacySecurityText')}
            </p>
          </section>

          <section className="policy-section" id="rights">
            <h2>{t('privacyRights')}</h2>
            <p>{t('privacyRightsText')}</p>
            <ul>
              <li>{t('privacyRights1')}</li>
              <li>{t('privacyRights2')}</li>
              <li>{t('privacyRights3')}</li>
              <li>{t('privacyRights4')}</li>
            </ul>
            <p>
              {t('privacyRightsContact')}{" "}
              <a href="mailto:[Insert contact email]">[Insert contact email]</a>
            </p>
          </section>

          <section className="policy-section" id="third-party">
            <h2>{t('privacyThirdParty')}</h2>
            <p>
              {t('privacyThirdPartyText')}
            </p>
          </section>

          <section className="policy-section" id="updates">
            <h2>{t('privacyUpdates')}</h2>
            <p>
              {t('privacyUpdatesText')}
            </p>
          </section>
        </div>
      </main>
    </>
  );
}
